import type { GetActivitiesSectionsQuery } from '../../../lesson-builder.graphql.generated';
import {
  ACTIVITIES_COMPONENT_TYPE_DOCUMENT,
  ACTIVITIES_COMPONENT_TYPE_EBOOK,
} from 'global/constants';
import { ComponentDocument, ComponentEbook } from '../../component.constants';
import { preloadFiles } from 'approot/shared/logic/preload-files';
import { getComponentsOfType } from './get-components-of-type';
import type { Pluck } from 'lib/gql/pluck';

export function preloadPdfFiles(
  section: Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections'>
) {
  const components = getComponentsOfType<ComponentDocument | ComponentEbook>({
    components: section.components,
    types: [
      ACTIVITIES_COMPONENT_TYPE_DOCUMENT,
      ACTIVITIES_COMPONENT_TYPE_EBOOK,
    ],
  });
  const urls: string[] = [];

  components.forEach(c => {
    if (c.stimulusResourceProperties?.link) {
      urls.push(c.stimulusResourceProperties.link);
    }
  });

  preloadFiles(urls);
}
